// public/js/modules/utils.js


export function debounce(func, delay) {
    let timeoutId;

    const debounced = function(...args) {
        const context = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(context, args), delay);
    };

    
    debounced.cancel = function() {
        clearTimeout(timeoutId);
    };

    return debounced;
}


export function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${minutes}:${formattedSeconds}`;
}


export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}


export function applyConditionalTooltip(element) {
    if (!element) return;
    
    setTimeout(() => {
        const isOverflowing = element.scrollWidth > element.clientWidth;
        const currentTitle = element.getAttribute('title');
        const textContent = element.textContent.trim();

        if (isOverflowing && currentTitle !== textContent) {
            element.setAttribute('title', textContent);
        } else if (!isOverflowing && currentTitle) {
            element.removeAttribute('title');
        }
    }, 100);
}


export function getOptimizedImageUrl(url, width = null, height = null) {
    if (!url) return url;

    
    if (url.startsWith('blob:') || url.startsWith('data:') || url.startsWith(window.location.origin)) {
        return url;
    }

    
    if (width == null || height == null) {
        return url;
    }

    const encodedUrl = encodeURIComponent(url);
    return `https://wsrv.nl/?url=${encodedUrl}&w=${Math.round(width)}&h=${Math.round(height)}&fit=inside&output=webp&q=85`;
}


export function preloadImage(url, { crossOrigin = 'anonymous' } = {}) {
    return new Promise((resolve, reject) => {
        if (!url) {
            resolve();
            return;
        }
        const img = new Image();
        if (crossOrigin && !url.startsWith(window.location.origin) && !url.startsWith('blob:') && !url.startsWith('data:')) {
            img.crossOrigin = crossOrigin;
        }
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to preload image: ${url}`));
        img.src = url;
    });
}


export function typewriterPlaceholder(element, text, speed = 50) {
    if (!element || !text) return;
    
    
    if (element._typewriterTimeout) {
        clearTimeout(element._typewriterTimeout);
        delete element._typewriterTimeout;
    }
    
    
    if (element._typewriterInterval) {
        clearInterval(element._typewriterInterval);
        delete element._typewriterInterval;
    }
    
    let index = 0;
    element.placeholder = '';
    
    element._typewriterInterval = setInterval(() => {
        if (index < text.length) {
            element.placeholder = text.substring(0, index + 1);
            index++;
        } else {
            clearInterval(element._typewriterInterval);
            delete element._typewriterInterval;
        }
    }, speed);
}